<template>
  <Report/>
</template>

<script>
import Report from './components/AnnualReport.vue'

export default {
  name: 'App',
  components: {
    Report
  }
}
</script>

<style>

</style>
